import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contatti from "@/pages/Contatti";
import CookiePolicy from "@/pages/CookiePolicy";
import DecretoDignita from "@/pages/DecretoDignita";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/decreto-dignita" element={<DecretoDignita />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
